<template>
  <div>
    <div v-show="showNav" class="nav-wrap" :class="{'scrolled': scrolled, 'nav-minimal': minimalNav}">
      <nav id="main-header">
        <div class="nav-inner clearfix complex">
          <div class="top-bar">
            <a href="/teams" class="logo">
              <img class="hidden-xs" src="~@/images/teams-logo.svg" alt="TunnelBear">
              <img class="visible-xs" src="~@/images/t-grey.svg" alt="TunnelBear">
            </a>
            <button id="mobile-menu" @click="toggleMobileMenu()" class="plain" aria-label="menu"></button>
          </div>
          <div class="drawer" :class="{'mobile-open': mobileMenuExpanded}">
            <div class="screen" @click="toggleMobileMenu()" aria-hidden="true"></div>
            <div id="nav-items">
              <div class="mobile-controls">
                <button @click="toggleMobileMenu()" class="plain link right close" aria-label="close navigation"></button>
              </div>
              <nav-team-admin v-if="menuType === 'teamAdmin'" :current="current" @logout="logout()" @closeNav="toggleMobileMenu()"></nav-team-admin>
              <nav-team-member v-else-if="menuType === 'teamMember'" :current="current" @logout="logout()" @closeNav="toggleMobileMenu()"></nav-team-member>
            </div>
          </div>
        </div>
        <div class="nav-inner minimal">
          <div class="top-bar">
            <a href="/teams" class="logo">
              <img src="~@/images/teams-logo.svg" alt="TunnelBear">
            </a>
          </div>
        </div>
      </nav>
      <div v-if="is.mobile() && !minimalNav" class="mobile-cta-nav" :class="{'show': mobileScrolled}" v-show="!mobileMenuExpanded">
        <img v-if="is.ios()" class="icon" src="./images/ios-icon.svg" alt="">
        <img v-else class="icon" src="./images/android-icon.svg" alt="">
        <div class="info">
          <div v-if="is.ios()">
            <p><strong>Get TunnelBear</strong></p>
            <p>For iPhone &amp; iPad</p>
          </div>
          <div v-else>
            <p><strong>Get TunnelBear</strong></p>
            <p>For Android</p>
          </div>
        </div>
        <a class="btn hollow" :href="is.ios() ? external.downloadLinks.ios : external.downloadLinks.android">Get</a>
      </div>
    </div>
  </div>
</template>

<script>
import services from '@/services/services.js'
import is from 'is_js'
import navTeamAdmin from './components/nav-team-admin/nav-team-admin'
import navTeamMember from './components/nav-team-member/nav-team-member'

export default {
  name: 'navigation',
  props: ['minimal'],
  components: {
    'nav-team-admin': navTeamAdmin,
    'nav-team-member': navTeamMember
  },
  data () {
    return {
      is: is,
      mobileMenuExpanded: false,
      scrolled: false,
      mobileScrolled: false
    }
  },
  computed: {
    current: function () {
      return this.$route.name
    },
    loggedIn: function () {
      return this.$store.getters.isLoggedIn
    },
    menuType: function () {
      let session = this.$store.getters.userData
      let menuType = 'public'
      if (session.teamRole) {
        if (session.teamRole === 'ADMIN') {
          menuType = 'teamAdmin'
        } else {
          menuType = 'teamMember'
        }
      }
      return menuType
    },
    minimalNav: function () {
      return this.minimal || this.menuType === 'public'
    },
    showNav: function () {
      return (this.$store.getters.isLoggedIn && this.$store.getters.userDataRequested) ||
        !this.$store.getters.isLoggedIn
    }
  },
  created: function () {
    window.addEventListener('scroll', this.calculateNavState)
  },
  methods: {
    toggleMobileMenu: function () {
      this.mobileMenuExpanded = !this.mobileMenuExpanded
      this.$emit('toggleScroll', this.mobileMenuExpanded)
    },
    calculateNavState: function () {
      this.scrolled = services.windowScrollTop() > 50
      this.mobileScrolled = services.windowScrollTop() > 450
    },
    logout: function () {
      this.$store.dispatch('logout').then((response) => {
        window.location.replace('/')
      })
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('scroll', this.calculateNavState)
  }
}
</script>

<style lang="stylus" src="./nav.styl">



// WEBPACK FOOTER //
// src/components/nav/nav.vue